import { Divider } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniDivider = withUnistyles(Divider)

export default UniDivider
